var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.747,
    height: 57.741,
    viewBox: "0 0 57.747 57.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61120",
    "data-name": "Group 61120",
    transform: "translate(0.804 0.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82252",
    "data-name": "Path 82252",
    d: "M39.154,37.413l-38-2.562A1.243,1.243,0,0,1,0,33.528L2.185,1.158A1.242,1.242,0,0,1,3.508,0l38,2.562a1.243,1.243,0,0,1,1.155,1.323l-2.183,32.37A1.242,1.242,0,0,1,39.154,37.413Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 5.854, 7.703)",
    fill: "none",
    stroke: "#a09ea6",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82253",
    "data-name": "Path 82253",
    d: "M8.1,4.328A4.055,4.055,0,1,1,4.327.009,4.055,4.055,0,0,1,8.1,4.328",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 12.418, 13.582)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82254",
    "data-name": "Path 82254",
    d: "M8.1,4.328A4.055,4.055,0,1,1,4.327.009,4.055,4.055,0,0,1,8.1,4.328Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 11.642, 12.644)",
    fill: "none",
    stroke: "#a09ea6",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82255",
    "data-name": "Path 82255",
    d: "M33.719,14.358a.467.467,0,0,0-.051-.247L26.583.615A1.134,1.134,0,0,0,24.829.28L15.873,8.105a1.6,1.6,0,0,1-2.249-.152l-2.885-3.3a1.6,1.6,0,0,0-2.271-.133L.438,11.783a.458.458,0,0,0-.151.31L0,16.352a.459.459,0,0,0,.427.49l32.494,2.191a.46.46,0,0,0,.489-.426Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 11.223, 22.52)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82256",
    "data-name": "Path 82256",
    d: "M0,11.908,8.514,4.2A1.135,1.135,0,0,1,10.13,4.3l3.5,4a1.134,1.134,0,0,0,1.6.107L24.529.28a1.134,1.134,0,0,1,1.754.335l7.026,13.628",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 10.777, 21.503)",
    fill: "none",
    stroke: "#a09ea6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82257",
    "data-name": "Path 82257",
    d: "M48.106,52.595,1.158,49.429A1.242,1.242,0,0,1,0,48.107L3.168,1.158A1.241,1.241,0,0,1,4.49,0L51.439,3.168a1.242,1.242,0,0,1,1.155,1.323L49.429,51.44A1.242,1.242,0,0,1,48.106,52.595Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 0, 3.669)",
    fill: "none",
    stroke: "#a09ea6",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.232e5ac04f324890e43d33320d412dc3.svg";
export { ForwardRef as ReactComponent };